module.exports = __webpack_public_path__ + "media/images/gallery/constellations/orion/ori_names-76b58399950dea317590973c153eb4c7.gif";